/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Alert, Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICookieComplianceViewProps } from './phibro-c-cookie-compliance';

const CookieComplianceView: React.FC<ICookieComplianceViewProps> = props => {
    const { CookieComplianceBanner, AlertProps, Content, acceptButton, text, links } = props;

    return (
        <Module {...CookieComplianceBanner}>
            <Alert className={AlertProps.className} color={AlertProps.color} fade={AlertProps.fade}>
                <Node {...Content}>
                    {text}
                    {links}
                </Node>

                <div className='ms-cookie-compliance__buttons'>{acceptButton}</div>
            </Alert>
        </Module>
    );
};

export default CookieComplianceView;
